import React from "react";

export const GabriellePerfume = () => {
  return <p className="gabrielle-perfume">Gabrielle Essence Eau De Perfum</p>;
};
